(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$translate', 'JhiLanguageService', 'translationHandler', '$window', 'Auth', 'Principal', 'VERSION', 'RELEASE_YEAR'];

    function stateHandler($rootScope, $translate, JhiLanguageService, translationHandler, $window, Auth, Principal, VERSION, RELEASE_YEAR) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;
            $rootScope.RELEASE_YEAR = RELEASE_YEAR;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function(event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                // Update the language
                JhiLanguageService.getCurrent().then(function(language) {
                    $translate.use(language);
                });
            });


            // log();
            // eslint-disable-next-line
            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess', function(event, toState) {
                // A state with no pageTitle is a modal or a layout shell opened OVER the page the
                // reader is on - the .new / .edit / .delete states all are. Leave the tab alone:
                // re-titling here is what used to turn "Entidades" into a bare brand the moment
                // someone clicked Editar. The page underneath has not changed.
                if (!toState.data || !toState.data.pageTitle) {
                    return;
                }

                // A real navigation: whatever record the previous page named is no longer the
                // subject, so drop it before the new page's own controller announces its own.
                translationHandler.clearSubject();
                translationHandler.updateTitle(toState.data.pageTitle);
            });

            $rootScope.$on('$destroy', function() {
                if (angular.isDefined(stateChangeStart) && stateChangeStart !== null) {
                    stateChangeStart();
                }
                if (angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null) {
                    stateChangeSuccess();
                }
            });
        }
    }
})();
